export default __webpack_public_path__ + "static/media/19t.37d3728c.jpg";